module.exports = __webpack_public_path__ + "static/media/MentorClaire.2eceec62.png";